import BaseDataProvider from "./BaseDataProvider";
import { gql } from "apollo-boost";
import { makeParamsString } from "./utils";
import _ from "lodash";

class LocationsDataProvider extends BaseDataProvider {
  async getList(resource, params) {
    console.log(
      "LocationsDataProvider.getList(" +
        resource +
        "," +
        JSON.stringify(params) +
        ")"
    );
    let offset = params.pagination.perPage
      ? (params.pagination.page - 1) * params.pagination.perPage
      : 0;
    let limit = params.pagination.perPage ? params.pagination.perPage : 10;
    const nameFilter = _.get(params, "filter.name", "");
    const name = nameFilter ? `%${nameFilter}%` : "";
    const GET = gql`
          query {
            LocationsSearch(name:"${name}" offset:${offset} limit:${limit}) {
              offset
              limit
              total
              data {
                id
                stableId
                name
                abbr
              }
            }
          }`;
    try {
      const response = await this.client.query({ query: GET });
      //console.log(JSON.stringify(response, null, 2));
      return response.data.LocationsSearch;
    } catch (err) {
      console.error(JSON.stringify(err, null, 2));
      return null;
    }
  }

  async getOne(resource, params) {
    const GET = gql`
          query {
            data: LocationByID(id:"${params.id}") {
              id
              stableId
              name
              abbr
            }
          }`;
    try {
      const response = await this.client.query({ query: GET });
      //console.log(JSON.stringify(response, null, 2));
      return { data: response.data.data };
    } catch (err) {
      console.error(JSON.stringify(err, null, 2));
      return null;
    }
  }

  async update(resource, params) {
    console.log(
      "LocationsDataProvider.update(" +
        resource +
        "," +
        JSON.stringify(params) +
        ")"
    );
    const objectInfo = JSON.parse(JSON.stringify(params.data));
    delete objectInfo.__typename;
    var objectString = JSON.stringify(objectInfo).replace(
      /"(\w+)"\s*:/g,
      "$1:"
    );
    objectString = objectString.substring(1, objectString.length - 1).trim();
    const MUTATION = gql`
          mutation {
            UpdateLocation(${objectString}) {
              id
              stableId
              name
              abbr
            }
          }`;
    try {
      const response = await this.client.mutate({ mutation: MUTATION });
      //console.log(JSON.stringify(response, null, 2));
      return { data: response.data.UpdateLocation };
    } catch (err) {
      console.error(JSON.stringify(err, null, 2));
      return null;
    }
  }

  async create(resource, params) {
    const CREATE_OBJECT = gql`
        mutation {
          CreateLocation(${makeParamsString(params)}) {
            id
            name
            stableId
            abbr
          }
        }`;
    const response = await this.client.mutate({ mutation: CREATE_OBJECT });
    return { data: response.data.CreateLocation };
  }
}

export default LocationsDataProvider;
